<header
  class="header-with-image section-inset-t has--sand-overlay scroll-trigger"
  id="header"
  [class.is--dark]="header?.darkHeader"
  (fstrInViewport)="setNavTheme($event)"
  [once]="false"
>
  <div class="container header-with-image__main pt-topbar" data-speed=".95">
    <h2
      *ngIf="title || header?.title"
      class="lh-09"
      [ngClass]="header?.darkHeader ? 'fs-display-3' : 'fs-display-1'"
      [class.text-max-width-xl]="!header?.fullWithTitle"
    >
      <ngx-dynamic-hooks
        [options]="{ sanitize: false, updateOnPushOnly: true }"
        [content]="
          title || header?.title || ''
            | highlight : 'highlight font-display fw-bold' : false : !header?.darkHeader : 'squiggle-01' : 'primary' : undefined : true
        "
        splitting
        [duration]="2000"
        [startTextAnimation]="inviewPort"
        [context]="{ delayAnimation: 400, startShapeAnimation: inviewPort }"
        class="splitting splitting--letter-in"
      ></ngx-dynamic-hooks>
    </h2>

    <!--<ng-content></ng-content>-->
  </div>

  <div class="header-with-image__figure" [class.section-inset-t]="!headerImage?.url">
    <div class="container">
      <div class="header-with-image__figure__image" *ngIf="headerImage?.url">
        <fstr-image
          class="d-block"
          [loading]="'eager'"
          [fetchPriority]="'high'"
          [image]="headerImage!"
          [alt]="headerImage?.alt || header?.label || 'header-image'"
          [imageSizes]="[400, 800, 1200, 1900]"
          data-speed="1.1"
        ></fstr-image>

        <app-text-shape
          [autoplay]="true"
          class="header-with-image__figure__image__shape"
          data-speed="1.1"
          shape="squiggle-03"
          *ngIf="!header?.darkHeader"
          shapeColor="secondary"
        ></app-text-shape>
      </div>
    </div>

    <div class="header-with-image__figure__text">
      <app-big-text [text]="backgroundTitle || header?.label || ('header-achtergrond-titel-default' | fromDictionary)"></app-big-text>
    </div>

    <app-scroll-indicator [text]="'header-scroll-indicator-text' | fromDictionary"></app-scroll-indicator>
  </div>
</header>
